import React      from 'react';
import classNames from 'classnames';

import { staticPageConstants } from '../../../../../common/constants/staticPageConstants';

import { GallerySlider } from '../../../../components/sliders';

function renderImageGalleryBlock(data, index) {

  return (
    <section
      key={index}
      className={classNames({
        'wide': data.SIZE === staticPageConstants.COMPONENTS.IMAGE_GALLERY.SETTINGS.SIZE.WIDE_SCREEN_SIZE,
      })}
      style={{ backgroundColor: data.BACKGROUND_COLOR }}
    >
      <GallerySlider
        slides={data.CONTENT
          .map(slide => ({
            title:       slide.LABEL,
            description: slide.CONTENT,
            src:       (slide.IMAGE || [])[0],
            alt:         slide.ALT || slide.LABEL,
            type: 'image',
          }))}
        fullSize={data.SIZE === staticPageConstants.COMPONENTS.IMAGE_GALLERY.SETTINGS.SIZE.WIDE_SCREEN_SIZE}
        showTitle={true}
        dots={data.CONTROLS === staticPageConstants.COMPONENTS.IMAGE_GALLERY.SETTINGS.CONTROLS.DOTS}
        previews={data.CONTROLS === staticPageConstants.COMPONENTS.IMAGE_GALLERY.SETTINGS.CONTROLS.PREVIEWS}
      />
    </section>
  );
}

export default renderImageGalleryBlock;